import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";

function Make(funarg) {
  var all_internal = {
    contents:
    /* [] */
    0
  };

  var add = function add(x) {
    var t = Curry._1(funarg.of_string, x);

    all_internal.contents =
    /* :: */
    [t, all_internal.contents];
    return t;
  };

  var neg = add("neg");
  var fneg = add("fneg");
  var not = add("not");
  var and_ = add("and");
  var or_ = add("or");
  var plus = add("+");
  var minus = add("-");
  var multiply = add("*");
  var div = add("div");
  var plus_float = add("+.");
  var minus_float = add("-.");
  var multiply_float = add("*.");
  var fdiv = add("fdiv");
  var equal = add("==");
  var not_equal = add("/=");
  var lt = add("<");
  var lte = add("<=");
  var gt = add(">");
  var gte = add(">=");
  var equal_float = add("==.");
  var not_equal_float = add("/=.");
  var lt_float = add("<.");
  var lte_float = add("<=.");
  var gt_float = add(">.");
  var gte_float = add(">=.");
  var equal_string = add("==~");
  var not_equal_string = add("/=~");
  var lt_string = add("<~");
  var lte_string = add("<=~");
  var gt_string = add(">~");
  var gte_string = add(">=~");
  var append = add("++");
  var identity = add("identity");
  var length = add("length");
  var concat = add("concat");
  var map = add("map");
  var mapi = add("mapi");
  var filter = add("filter");
  var fold = add("fold");
  var hd = add("hd");
  var tl = add("tl");
  var empty = add("empty");
  var $$int = add("int");
  var bool = add("bool");
  var $$char = add("char");
  var $$float = add("float");
  var string = add("string");
  var fastq = add("fastq");
  var print_fastq = add("print_fastq");
  var sam = add("sam");
  var fasta = add("fasta");
  var csv = add("csv");
  var gunzip = add("gunzip");
  var maybe = add("maybe");
  var base64_decode = add("base64_decode");
  var biom = add("biom");
  var csv_of_biom = add("csv_of_biom");
  var indexed_dataframe = add("indexed_dataframe");
  var newick = add("newick");
  var html = add("html");
  var png = add("png");
  var bam = add("bam");
  var bam_index = add("bam_index");
  var fasta_index = add("fasta_index");
  var bed = add("bed");
  var big_bed = add("big_bed");
  var big_wig = add("big_wig");
  var gtf = add("gtf");
  var gff = add("gff");
  var vcf = add("vcf");
  var vcf_index = add("vcf_index");
  var gzip = add("gzip");
  var print_int = add("print_int");
  var print_bool = add("print_bool");
  var print_string = add("print_string");
  var print_float = add("print_float");
  var print_char = add("print_char");
  var print_solvuu = add("print_solvuu");
  var print_maybe = add("print_maybe");
  var print_csv = add("print_csv");
  var uri = add("uri");
  var stats = add("stats");
  var histogram = add("histogram");
  var t_test = add("t_test");
  var cat = add("cat");
  var echo = add("echo");
  var ls = add("ls");
  var date = add("date");
  var bigbed = add("bigbed");
  var bigwig = add("bigwig");
  var ascii = add("ascii");
  var bash = add("bash");
  var cram = add("cram");
  var cram_index = add("cram_index");
  var bytes = add("bytes");
  var json = add("json");
  var qza = add("qza");
  var multiQC = add("multiQC");
  var rdata = add("rdata");
  var solvuu = add("solvuu");
  var solvuu_json = add("solvuu_json");
  var solvuu_runtime_json = add("solvuu_runtime_json");
  var solvuu_eval_json = add("solvuu_eval_json");
  var solvuu_type = add("solvuu_type");
  var solvuu_type_json = add("solvuu_type_json");
  var solvuu_fmt = add("solvuu_fmt");
  var solvuu_fmt_json = add("solvuu_fmt_json");
  var solvuu_bigdata = add("solvuu_bigdata");
  var solvuu_dataframe = add("solvuu_dataframe");
  var area_chart = add("area_chart");
  var bar_chart = add("bar_chart");
  var box_plot = add("box_plot");
  var bubble_chart = add("bubble_chart");
  var donut_chart = add("donut_chart");
  var dot_plot = add("dot_plot");
  var heat_map = add("heat_map");
  var hexbin_plot = add("hexbin_plot");
  var kernel_density = add("kernel_density");
  var krona_chart = add("krona_chart");
  var line_chart = add("line_chart");
  var parallel_coordinates = add("parallel_coordinates");
  var principal_coordinates = add("principal_coordinates");
  var quantile_quantile_plot = add("quantile_quantile_plot");
  var scatter_plot = add("scatter_plot");
  var scatter_matrix = add("scatter_matrix");
  var summary_statistics = add("summary_statistics");
  var venn_diagram = add("venn_diagram");
  var violin_plot = add("violin_plot");
  var volcano_plot = add("volcano_plot");
  var rnaseq = add("rnaseq");
  var paired_fastq_to_unmapped_bam = add("paired_fastq_to_unmapped_bam");
  var whole_genome_germline_single_sample = add("whole_genome_germline_single_sample");
  var exome_germline_single_sample = add("exome_germline_single_sample");
  var fastq_to_ubam = add("fastq_to_ubam");
  var celmatix_merge_bam_alignment = add("celmatix_merge_bam_alignment");
  var celmatix_mark_duplicates = add("celmatix_mark_duplicates");
  var celmatix_bqsr_table = add("celmatix_bqsr_table");
  var celmatix_downsample_ubam = add("celmatix_downsample_ubam");
  var fastq_stats = add("fastq_stats");
  var sorted = Bolt0_list$Bolt0.sort(funarg.compare, all_internal.contents);
  var match = Bolt0_list$Bolt0.fold_left(function (param, x) {
    var acc = param[1];
    var last_seen = param[0];

    if (last_seen !== undefined) {
      var match = Curry._2(funarg.compare, Caml_option.valFromOption(last_seen), x);

      if (match !== 0) {
        return (
          /* tuple */
          [Caml_option.some(x),
          /* :: */
          [x, acc]]
        );
      } else {
        return Pervasives.failwith("Duplicate detected");
      }
    } else {
      return (
        /* tuple */
        [Caml_option.some(x),
        /* :: */
        [x, acc]]
      );
    }
  },
  /* tuple */
  [undefined,
  /* [] */
  0], sorted);

  var all = Curry._1(funarg.of_list, match[1]);

  return {
    all: all,
    neg: neg,
    fneg: fneg,
    not: not,
    and_: and_,
    or_: or_,
    plus: plus,
    minus: minus,
    multiply: multiply,
    div: div,
    plus_float: plus_float,
    minus_float: minus_float,
    multiply_float: multiply_float,
    fdiv: fdiv,
    equal: equal,
    not_equal: not_equal,
    lt: lt,
    lte: lte,
    gt: gt,
    gte: gte,
    equal_float: equal_float,
    not_equal_float: not_equal_float,
    lt_float: lt_float,
    lte_float: lte_float,
    gt_float: gt_float,
    gte_float: gte_float,
    equal_string: equal_string,
    not_equal_string: not_equal_string,
    lt_string: lt_string,
    lte_string: lte_string,
    gt_string: gt_string,
    gte_string: gte_string,
    append: append,
    identity: identity,
    length: length,
    concat: concat,
    map: map,
    mapi: mapi,
    filter: filter,
    fold: fold,
    hd: hd,
    tl: tl,
    empty: empty,
    $$int: $$int,
    bool: bool,
    $$char: $$char,
    $$float: $$float,
    string: string,
    fastq: fastq,
    print_fastq: print_fastq,
    sam: sam,
    fasta: fasta,
    csv: csv,
    gunzip: gunzip,
    maybe: maybe,
    base64_decode: base64_decode,
    biom: biom,
    csv_of_biom: csv_of_biom,
    indexed_dataframe: indexed_dataframe,
    newick: newick,
    html: html,
    png: png,
    bam: bam,
    bam_index: bam_index,
    fasta_index: fasta_index,
    bed: bed,
    big_bed: big_bed,
    big_wig: big_wig,
    gtf: gtf,
    gff: gff,
    vcf: vcf,
    vcf_index: vcf_index,
    gzip: gzip,
    print_int: print_int,
    print_bool: print_bool,
    print_string: print_string,
    print_float: print_float,
    print_char: print_char,
    print_solvuu: print_solvuu,
    print_maybe: print_maybe,
    print_csv: print_csv,
    uri: uri,
    stats: stats,
    histogram: histogram,
    t_test: t_test,
    cat: cat,
    echo: echo,
    ls: ls,
    date: date,
    bigbed: bigbed,
    bigwig: bigwig,
    ascii: ascii,
    bash: bash,
    cram: cram,
    cram_index: cram_index,
    bytes: bytes,
    json: json,
    qza: qza,
    multiQC: multiQC,
    rdata: rdata,
    solvuu: solvuu,
    solvuu_json: solvuu_json,
    solvuu_runtime_json: solvuu_runtime_json,
    solvuu_eval_json: solvuu_eval_json,
    solvuu_type: solvuu_type,
    solvuu_type_json: solvuu_type_json,
    solvuu_fmt: solvuu_fmt,
    solvuu_fmt_json: solvuu_fmt_json,
    solvuu_bigdata: solvuu_bigdata,
    solvuu_dataframe: solvuu_dataframe,
    area_chart: area_chart,
    bar_chart: bar_chart,
    box_plot: box_plot,
    bubble_chart: bubble_chart,
    donut_chart: donut_chart,
    dot_plot: dot_plot,
    heat_map: heat_map,
    hexbin_plot: hexbin_plot,
    kernel_density: kernel_density,
    krona_chart: krona_chart,
    line_chart: line_chart,
    parallel_coordinates: parallel_coordinates,
    principal_coordinates: principal_coordinates,
    quantile_quantile_plot: quantile_quantile_plot,
    scatter_plot: scatter_plot,
    scatter_matrix: scatter_matrix,
    summary_statistics: summary_statistics,
    venn_diagram: venn_diagram,
    violin_plot: violin_plot,
    volcano_plot: volcano_plot,
    rnaseq: rnaseq,
    paired_fastq_to_unmapped_bam: paired_fastq_to_unmapped_bam,
    whole_genome_germline_single_sample: whole_genome_germline_single_sample,
    exome_germline_single_sample: exome_germline_single_sample,
    fastq_to_ubam: fastq_to_ubam,
    celmatix_merge_bam_alignment: celmatix_merge_bam_alignment,
    celmatix_mark_duplicates: celmatix_mark_duplicates,
    celmatix_bqsr_table: celmatix_bqsr_table,
    celmatix_downsample_ubam: celmatix_downsample_ubam,
    fastq_stats: fastq_stats
  };
}

export { Make };
/* No side effect */